// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"SearchResults--searchResults--3B5gm"};